import { Component, OnInit, ViewChild } from '@angular/core';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ImageFile } from '../../../../../../shared/_data-model/image-file';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../../../../environments/environment';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { ValidationService } from '../../../../../../shared/_services/validation.service';
import { GetJsonService } from '../../../../../../shared/_services/get-json.service';

@Component({
  selector: 'app-landing-page-next-step',
  templateUrl: './landing-page-next-step.component.html',
  styleUrls: ['./landing-page-next-step.component.scss']
})
export class LandingPageNextStepComponent implements OnInit {
  spanish: any;
  english: any;
  successMsg: string;
  isDirtyEn: boolean = false;
  isDirtyEs: boolean = false;
  upcomingVisitEn: FormGroup;
  upcomingVisitEs: FormGroup;
  pastVisitEn: FormGroup;
  pastVisitEs: FormGroup;
  brand: any;
  imageUrl: any;
  imageFile: any;
  errorUpload: any;
  newMemberEn: FormGroup;
  newMemberEs: FormGroup;
  errorDetails: any;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  private subscription: Subscription;
  environment = environment;
  formMapping: any = {
    'newMemberConfigTos': 'initNewMemberForm',
    'pastBookingConfigurationTos': 'initPastVisitForm',
    'upcomingBookingConfigurationTos': 'initUpcomingVisitForm'
  }
  @ViewChild('uploadTileImg') uploadTileImg: any;
  @ViewChild('uploadTileImgEs') uploadTileImgEs: any;
  @ViewChild('uploadTileImgDiv') uploadTileImgDiv: any;
  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private utilService: UtilService,
    private validationService: ValidationService,
    private loyaltyService: LoyaltyService,
    private hotelManagementService: HotelManagementService,
    public modalService: BsModalService,
    private getJsonService:GetJsonService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.type == "hca-wizard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              // Resets the form data
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-image") {
            if (this.statusModal.content.srcObject.action == "action1") {
              const form = this.statusModal.content.srcObject.form;
              const i = this.statusModal.content.srcObject.i;
              this.removeImage(form, i);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-remove") {
            if (this.statusModal.content.srcObject.action == "action1") {
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              this.removeControl(form, control, i);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-next-step") {
            if (this.statusModal.content.srcObject.action == "action1") {
              if (this.isDirtyEn == true) {
                this.isDirtyEn = false;
                setTimeout(() => {
                  this.getMemberConfigData(this.brand.brandId);
                  let element = document.getElementById("es1");
                  element.click();
                }, 50);
              }
              if (this.isDirtyEs == true) {
                this.isDirtyEs = false;
                setTimeout(() => {
                  this.getMemberConfigData(this.brand.brandId);
                  let element = document.getElementById("en1");
                  element.click();
                }, 50);
              }
            }
          }
        }
      })
  }

  getMemberConfigData(brandId) {
    this.initForm();
    this.loyaltyService.getMemberConfigData(brandId).subscribe(res => {
      if (res.error == 0) {
        if (res.responseObj) {
          Object.keys(res.responseObj).forEach(data => {
            Object.keys(this.formMapping).forEach(type => {
              if (data == type) {
                res.responseObj[data].forEach(res => {
                  this[this.formMapping[type]](res, res.languageId);
                })
              }
            })
          })
        } else {
          this.initForm();
        }
      }
    }, err => {
      console.error('Error fetching loyalty website header and footer data', err);
    })

  }

  getImgStyle(id, imgSrc) {

    return `${environment.BASE_IMAGE_API}/images/newmember/tile/${id}/${imgSrc}`;
  }

  saveForm() {
    let formData = {
      brandId: this.brand.brandId,
      memberUpgradeConfigurationTo: {
        newMemberConfigTos: [this.newMemberEn.value, this.newMemberEs.value],
        pastBookingConfigurationTos: [this.pastVisitEn.value, this.pastVisitEs.value],
        upcomingBookingConfigurationTos: [this.upcomingVisitEn.value, this.upcomingVisitEs.value]
      }
    }
    this.loyaltyService.saveLoyaltyWebsite(formData).subscribe(res => {
      console.log(res);
      this.isDirtyEs = false;
      this.isDirtyEn = false;
      this.successMsg = 'Saved successfully';
      if(res.responseObj && res.responseObj.memberUpgradeConfigurationTo) {
        Object.keys(res.responseObj.memberUpgradeConfigurationTo).forEach(data => {
          Object.keys(this.formMapping).forEach(type => {
            if (data == type) {
              res.responseObj.memberUpgradeConfigurationTo[data].forEach(res => {
                this[this.formMapping[type]](res, res.languageId);
              })
            }
          })
        })
      }
      setTimeout(() => {
        this.successMsg = '';
      }, 1000);
    }, err => {
      this.errorDetails = err.message ? err.message : 'Error while saving';
      setTimeout(() => {
        this.errorDetails = '';
      }, 1000);
      console.error('Error Saving ', err.message);
    })
  }

  fileChanged(event: any, control?, tileIdx?, uploadType?, eleLength?) {
    const tileCtrl = <FormArray>this[control].controls['tilesTo'];
    const tileIdxCtrl = tileCtrl.at(tileIdx);
    console.log('===================uploadTileImgDiv========', this.uploadTileImgDiv);
    let image = URL.createObjectURL(event.target.files[0]);
    console.log('image:::++', image);
    let fileList: FileList = event.target.files;
    this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image);
    this.imageFile = event.target.files[0];
    this.removeImage(control, tileIdx);
    this.errorUpload = false;
    if (fileList.length > 0 && (this.imageFile.type === 'image/png' || this.imageFile.type === 'image/jpg' || this.imageFile.type === 'image/jpeg')) {
      tileIdxCtrl.get('imageError').patchValue(false);
      this.errorUpload = false;
    } else {
      tileIdxCtrl.get('imageError').patchValue(true);
      setTimeout(() => {
        tileIdxCtrl.get('imageError').patchValue(false);
      }, 1500);
      this.resetFileInput(control, eleLength);
      this.errorUpload = true;
      console.log('Please upload Images only');
    }
    let formData: any = new FormData();
    if (this.imageFile) {
      let fileName = this.imageFile.name ? this.utilService.getModifiedString(this.imageFile.name) : this.utilService.getRandomInt(0, 1000000);
      formData.append('image', this.imageFile, fileName);
    } else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('image', file, null);
    }
    if (!this.errorUpload) {
      this.utilService.uploadFile(formData).subscribe((res) => {
        if (res.error == 0) {
          tileIdxCtrl.get('image').patchValue(res.responseObj);
          tileIdxCtrl.get('imageUrl').patchValue(this.imageUrl);
        }
        this.resetFileInput(control, eleLength);
      }, error => {
        this[control].get('imageError').patchValue(error.message);
        this.errorUpload = error.message;
        this.resetFileInput(control, eleLength);
        console.log('========res ===========', error);
      })
    }
  }

  removeImage(control, idx) {
    const tileCtrl = <FormArray>this[control].controls['tilesTo'];
    const tileIdxCtrl = tileCtrl.at(idx);
    tileIdxCtrl.get('image').patchValue(null, { emitEvent: false });
    tileIdxCtrl.get('imageUrl').patchValue(null, { emitEvent: false });
    tileIdxCtrl.get('imageError').patchValue(false, { emitEvent: false });
  }

  resetFileInput(element?, fileLength?) {
    if (fileLength > 1) {
      for (let i = 0; i < fileLength; i++) {
        (<HTMLInputElement>document.querySelector(`.tile#${element}-${i}`)).value = null;
      }
    } else {
      (<HTMLInputElement>document.querySelector(`.tile#${element}-0`)).value = null;
    }
  }

  removeControl(form, control, i) {
    const formControl = <FormArray>this[form].controls[control];
    formControl.removeAt(i);
  }

  deleteImage(form, i, language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.DELETE_IMAGE;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.DELETE_IMAGE;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      form: form,
      control: null,
      i: i,
      type2: null,
      imageType: null
    }
  }

  remove(form, control, i, language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.REMOVE_MESSAGE;
      action1 = this.english.MODAL.REMOVE;
      action2 = this.english.MODAL.CANCEL;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.REMOVE_MESSAGE;
      action1 = this.spanish.MODAL.REMOVE;
      action2 = this.spanish.MODAL.CANCEL;
    }
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-remove',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      style: 'inactive',
      form: form,
      control: control,
      i: i,
      type2: null
    }
  }

  addTiles(tileData?: any, control?) {
    let tileForm = this[control].get('tilesTo') as FormArray;
    tileForm.push(this.fb.group({
      earnPoints: [tileData ? tileData.earnPoints : ''],
      actionUrl: [tileData ? tileData.actionUrl : '', [Validators.pattern(this.validationService.webUrl_regexPattern)]],
      image: [tileData ? tileData.image : ''],
      imageUrl: [null],
      imageError: [false],
      tilesHeading: [tileData ? tileData.tilesHeading : ''],
      id: [tileData ? tileData.id : '']
    }))
  }

  addPerks(perkData?: any, control?) {
    let perkForm = this[control].get('perkDescription') as FormArray;
    perkForm.push(new FormControl(perkData ? perkData : null));
  }

  newMemberForm(data?, languageId?, control?) {
    return this.fb.group({
      id: [data ? data.id : null],
      heading: [data ? data.heading : null],
      languageId: [languageId ? languageId : null],
      loyaltyWebsiteId: [data ? data.loyaltyWebsiteId : null],
      subHeading: [data ? data.subHeading : null],
      tilesTo: this.fb.array([])
    })
  }

  pastVisitForm(data?, languageId?) {
    return this.fb.group({
      heading: [data ? data.heading : null],
      languageId: [languageId ? languageId : null],
      websiteId: [data ? data.websiteId : null],
      subHeading: [data ? data.subHeading : null],
      id: [data ? data.id : null]
    })
  }

  setPointvalidators(ctrl, key, value) {
    // controls
    const bannerCtrl = (<any>this[ctrl]).controls[key];
    const bannerValueCtrl = (<any>this[ctrl]).controls[value];

    // initialize value changes stream
    const bannerChanges$ = bannerCtrl.valueChanges;
    bannerChanges$.subscribe(buttonType => {
      if (buttonType == 'External URL') {
        bannerValueCtrl.setValidators([Validators.required, Validators.pattern(this.validationService.webUrl_regexPattern)]);
        bannerValueCtrl.updateValueAndValidity();
      } else {
        bannerValueCtrl.patchValue(null, { emitEvent: false });
        bannerValueCtrl.setValidators(null);
        bannerValueCtrl.updateValueAndValidity();
      }
    })
  }

  upcomingVisitForm(data?, languageId?) {
    return this.fb.group({
      heading: [data ? data.heading : null],
      languageId: [languageId ? languageId : null],
      loyaltyWebsiteId: [data ? data.loyaltyWebsiteId : null],
      subHeading: [data ? data.subHeading : null],
      id: [data ? data.id : null],
      message: [data ? data.message : null],
      perkHeading: [data ? data.perkHeading : null],
      perkMessage: [data ? data.perkMessage : null],
      buttonText: [data ? data.buttonText : null],
      buttonActionType: [data && data.buttonActionType ? data.buttonActionType : 'Book Now'],
      externalUrl: [data ? data.externalUrl : null],
      // perkDescription: this.fb.array([])
    })
  }

  initNewMemberForm(data?, langType?) {
    if (langType == 'en' || langType == 1) {
      this.newMemberEn = this.newMemberForm(data ? data : null, 1, 'newMemberEn');
      if (!data || data.tilesTo.length < 1) {
        this.addTiles(null, 'newMemberEn');
      } else {
        data.tilesTo.forEach(tile => {
          this.addTiles(tile, 'newMemberEn');
        })
      }
      this.newMemberEn.valueChanges.subscribe(data => {
        if (this.newMemberEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.newMemberEs = this.newMemberForm(data ? data : null, 2, 'newMemberEs');
      if (!data || data.tilesTo.length < 1) {
        this.addTiles(null, 'newMemberEs');
      } else {
        data.tilesTo.forEach(tile => {
          this.addTiles(tile, 'newMemberEs');
        })
      }
      this.newMemberEs.valueChanges.subscribe(data => {
        if (this.newMemberEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initPastVisitForm(data?, langType?) {
    if (langType == 'en' || langType == 1) {
      this.pastVisitEn = this.pastVisitForm(data ? data : null, 1);
      this.pastVisitEn.valueChanges.subscribe(data => {
        if (this.pastVisitEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.pastVisitEs = this.pastVisitForm(data ? data : null, 2);
      this.pastVisitEn.valueChanges.subscribe(data => {
        if (this.pastVisitEn.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initUpcomingVisitForm(data?, langType?) {
    if (langType == 'en' || langType == 1) {
      this.upcomingVisitEn = this.upcomingVisitForm(data ? data : null, 1);
      // if (!data || data.perkDescription.length < 1) {
      //   [1, 2, 3, 4].forEach(perk => {
      //     this.addPerks(null, 'upcomingVisitEn');
      //   })
      // } else {
      //   data.perkDescription.forEach(perk => {
      //     this.addPerks(perk, 'upcomingVisitEn');
      //   })
      // }
      this.setPointvalidators('upcomingVisitEn', 'buttonActionType', 'externalUrl');
      this.upcomingVisitEn.valueChanges.subscribe(data => {
        if (this.upcomingVisitEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.upcomingVisitEs = this.upcomingVisitForm(data ? data : null, 2);
      // if (!data || data.perkDescription.length < 1) {
      //   [1, 2, 3, 4].forEach(perk => {
      //     this.addPerks(null, 'upcomingVisitEs');
      //   })
      // } else {
      //   data.perkDescription.forEach(perk => {
      //     this.addPerks(perk, 'upcomingVisitEs');
      //   })
      // }
      this.setPointvalidators('upcomingVisitEs', 'buttonActionType', 'externalUrl');
      this.upcomingVisitEs.valueChanges.subscribe(data => {
        if (this.upcomingVisitEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }
  getEnglishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "en.json")
      .subscribe(
      (res) => {
        this.english = res;
        console.log("English Translations: " + res);
      },
      (err) => console.error("English Translations" + err));

  }
  getSpanishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "es.json")
      .subscribe(
      (res) => {
        this.spanish = res;
        console.log("Spanish Translations: " + res);
      },
      (err) => console.error("Spanish Translations" + err));
  }

  initForm() {
    this.initNewMemberForm(null, 'en');
    this.initNewMemberForm(null, 'es');
    this.initPastVisitForm(null, 'en');
    this.initPastVisitForm(null, 'es');
    this.initUpcomingVisitForm(null, 'en');
    this.initUpcomingVisitForm(null, 'es');
  }

  ngOnInit() {
    this.subscription = this.loyaltyService.brandState
      .subscribe((state: any) => {
        this.brand = state.brand;
        this.getMemberConfigData(this.brand.brandId);
      });
    this.initForm();
    this.getEnglishTranslations();
    this.getSpanishTranslations();
  }

  ngAfterViewInit() {
    this.brand = this.hotelManagementService.getSelectedBrand();
    this.getMemberConfigData(this.brand.brandId);
  }
  changeLanguage() {
    if (this.isDirtyEn == true) {
      this.stayOnPage("english");
    }
    else if (this.isDirtyEs == true) {
      this.stayOnPage("spanish");
    }
  }
  stayOnPage(language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.NOT_SAVED;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.NOT_SAVED;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }

    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-next-step',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      style: 'active'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/landing-page-next-step/landing-page-next-step.component.ts